/** Shade swatch images shared by the F.I.T. shade and additional syringe selectors. */
const SHADE_IMAGES = {
    'Masking Liner': '/img/shade/MaskingLinear.png',
    XBW: '/img/shade/XBW.jpg',
    BW: '/img/shade/BW.jpg',
    A1: '/img/shade/A1.jpg',
    A2: '/img/shade/A2.jpg',
    A3: '/img/shade/A3.jpg',
    'A3.5': '/img/shade/A3.5.jpg',
    A4: '/img/shade/A4.jpg',
    B1: '/img/shade/B1.jpg',
    B2: '/img/shade/B2.jpg',
    AO1: '/img/shade/A01.jpg',
    AO2: '/img/shade/A02.jpg',
    AO3: '/img/shade/A03.jpg',
    JE: '/img/shade/JE.jpg',
    AE: '/img/shade/AE.jpg',
};

/** Preloads every shade swatch so its button renders as soon as it becomes visible. */
export const preloadShadeImages = () => {
    Object.values(SHADE_IMAGES).forEach((src) => {
        const image = new Image();
        image.src = src;
    });
};

export default SHADE_IMAGES;
